/**
 * Visually-hidden "Skip to main content" link that becomes visible on
 * keyboard focus. Required for WCAG 2.4.1 (Bypass Blocks). Targets the
 * `#main` landmark rendered by each page's <main> element.
 */
const SkipToContent = () => (
  <a
    href="#main"
    className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
  >
    Skip to main content
  </a>
);

export default SkipToContent;
